import "./index.less";



// WEBPACK FOOTER //
// ./ecology9/wea-report/style/index.js